export const company_profile_display_strings = {
  title: "Company Profile",
  description: "View company profile information",

  // Field labels
  logoLabel: "Logo",
  logoAlt: "Company Logo",
  nameLabel: "Company Name",
  dbaLabel: "Doing Business As (DBA)",
  emailLabel: "Email Address",
  phoneLabel: "Phone Number",
  websiteLabel: "Website",
  aboutLabel: "About",
  yearFoundedLabel: "Year Founded",
  addressLabel: "Address",
  addressFormattedLabel: "Formatted Address",
  addressStreetLabel: "Street",
  addressCityStateLabel: "City, State",
  addressCountryZipLabel: "Country, ZIP",
  socialUrlsLabel: "Social Media",
  createdAtLabel: "Created",
  updatedAtLabel: "Last Updated",

  // Standard states
  empty: "No company profile found",
};
